<div id="onboarding-payment-page">

  <div class="container-state-img">
    <img ngSrc="assets/images/payment-processing.svg" alt="Icon payment processing" height="80" width="80">
  </div>

  <app-onboarding-header
    title="Paiement en cours de validation"
    content="Encore un instant, le paiment est en cours de validation par la banque. Vous recevrez prochainement un email de confirmation pour accéder à votre compte.">
    [isStepperTitle]="true">
  </app-onboarding-header>

  <div class="container-actions">
    <button mat-stroked-button (click)="leave()"
            class="full-width size-xl base"
            type="button">
      Quitter
    </button>
  </div>
</div>
